//
// ユーザー向けのSmE内での規約画面
//

// リッチテキスト内のリンクを別タブで開く
document.addEventListener("DOMContentLoaded", () => {
  const pages = document.querySelectorAll('.service_agreement-page')
  if (pages.length == 0) return

  document.querySelectorAll('a').forEach((link) => {
    link.target = "_blank"
    link.rel = "noopener noreferrer"
  })
})
